const dollarFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
})

export const formatDollarsToCents = (value) => {
  let next = `${value ?? ''}`.replace(/[^\d.-]/g, '')
  if (next && next.includes('.')) {
    next = next.substring(0, next.indexOf('.') + 3)
  }
  return next ? Math.round(parseFloat(next) * 100) : 0
}

export const formatCentsToDollars = (value, { asString = false } = {}) => {
  const numeric = Number(`${value ?? ''}`.replace(/[^\d.-]/g, ''))
  if (!Number.isFinite(numeric)) return asString ? '0.00' : 0
  const dollars = numeric / 100
  return asString ? dollars.toFixed(2) : dollars
}

export const displayAsDollars = (value) =>
  dollarFormatter.format(formatCentsToDollars(value))

export const displayFromDollars = (value) => {
  const numeric = Number(`${value ?? ''}`.replace(/[^\d.-]/g, ''))
  const dollars = Number.isFinite(numeric) ? numeric : 0
  return dollarFormatter.format(dollars)
}

export const displayFromCents = (value) => displayAsDollars(value)

export { dollarFormatter }
